export enum TanStackQueryIds {
  TABLE_ROWS_COLUMNS = 'table-rows-columns',
  STRIPE_ACCOUNT_STATE = 'stripe-account-state',
  LIST_ELEMENTALS = 'list-elementals',
  PROFILE_LIST_ELEMENTALS = 'profile-list-elementals',
  LIST_ITEMS_INFINITY = 'list-items-infinity',
  LIST_TREE_INFINITY = 'list-tree-infinity',
  HOME_FEED_INFINITY = 'home-feed-infinity',
  LIST_FOLDERS = 'list-folders',
  ELEMENTAL_COMMENTS_INFINITY = 'elemental-commnets-infinity',
  KNOWLEDGE_BASE = 'knowledge-base',
  ELEMENTALS_INFINITY = 'elementals-infinity',
  ELEMENTAL_INFOS = 'elemental-infos',
  ELEMENTAL = 'elemental',
  ADS_STATUS = 'ads-status',
  RECENT_ELEMENTAL = 'recent-elemental',
  PROFILE_LIST_ELEMENTALS_INFINITY = 'profile-list-elementals-infinity',
  ELEMENTAL_TAGS = 'elemental-tags',
  FAVORITES = 'favorites',
}
